<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <v-col cols="1">
          <v-btn icon dark disabled>
            <v-icon size="30">mdi-arrow-left-bold-box-outline</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length > 0"
                @click="addRecord()"
              >
                <v-icon size="30">mdi-file-plus-outline</v-icon>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                @click="editRecord(selectedRows[0].job_id,false)"
                class="ml-1"
              >
                <v-icon size="30">mdi-clipboard-edit-outline</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                :to="(selectedRows[0])?'customer/edit/'+selectedRows[0].customer_id:''"
                class="ml-1"
              >
                <v-icon size="30">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
                @click="delete_dialog = true"
                class="ml-1"
              >
                <v-icon size="30">mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>

        <v-col cols="2" class="d-flex align-center">
          <!-- <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="open_doc_model_falg || open_log_model_falg" icon small dark v-bind="attrs" v-on="on" class="mr-1">
                <v-badge overlap dot :value="search || pagination.filters.alphabet" color="error">
                  <v-icon size="30">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="400">
              <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  solo
                  clearable
                  autofocus
                  v-on:keyup.enter="search_menu = false"
                ></v-text-field>
              </v-col>
              </v-row>
            </v-card>
          </v-menu>-->
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="pagination.filters.alphabet = ''"
                :disabled="open_doc_model_falg || open_log_model_falg"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-1"
              >
                <v-icon>mdi-filter-menu-outline</v-icon>
              </v-btn>
            </template>
            <v-card tile max-width="400" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item class="mt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    dense
                    outlined
                    placeholder=" "
                    clearable
                    autofocus
                    v-on:keyup.enter="search_menu = false"
                    class="mr-2"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="error"
                        @click="resetFilter()"
                        icon
                        small
                      >
                        <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Reset</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="status"
                    outlined
                    label="Status"
                    hide-details
                    class="body-2"
                    placeholder=" "
                    v-model="pagination.filters.active"
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>

        <v-col cols="2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openDocList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-1"
              >
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  overlap
                >
                  <v-icon size="30">mdi-dresser-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Documents</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openLogList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-1"
              >
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  overlap
                >
                  <v-icon size="30">mdi-file-document-multiple-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Logs</span>
          </v-tooltip>
        </v-col>

        <v-col cols="2">
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="setting_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" class="ml-1">
                <v-icon>mdi-cog-outline</v-icon>
              </v-btn>
            </template>
            <v-card tile max-width="197" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-row dense class="pl-3 pr-3 pt-1">
                  <v-col cols="12">
                    <v-text-field
                      dense
                      flat
                      outlined
                      label="Markup %"
                      hide-details
                      class="body-2"
                      placeholder=" "
                      type="number"
                      v-model="setting_data.markup"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      small
                      @click="updateSetting('yes')"
                      block
                      color="primary"
                      class="text-capitalize"
                    >Update All</v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      small
                      block
                      @click="updateSetting('no')"
                      color="primary"
                      class="text-capitalize"
                    >Update Future Records</v-btn>
                  </v-col>
                </v-row>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="setting_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>

        <v-col cols="2" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">Job</span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background: none" flat>
      <v-card-text class="pa-0 mx-auto">
        <v-row dense style="width:100%" class="pa-0 ma-0">
          <v-col cols="2" class="pt-0 pr-0 alphabet-sort-max-width">
            <v-row dense class="alphabet-section">
              <v-col cols="12" class="text-center">
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:15px;"
                  :class="(pagination.filters.alphabet == '')?'primary':''"
                  class="text-capitalize"
                  @click="pagination.filters.alphabet = ''"
                >All</v-btn>
              </v-col>

              <v-col
                cols="12"
                v-for="(alphabet, index) in alphabets"
                :key="index"
                class="text-center pa-0"
                :style="alphabet.text == 'Z' 
                  ? 'padding-top: 1px !important; padding-bottom: 11px !important;' 
                  : 'padding-bottom: 2px !important;'"
              >
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:14px;"
                  :disabled="alphabet.disable"
                  :class="(pagination.filters.alphabet == alphabet.value) ? 'primary' : ''"
                  @click="pagination.filters.alphabet = alphabet.value"
                >{{ alphabet.text }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header custom-width-1328"
              item-key="job_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              :show-expand="true"
              single-expand
              :expanded.sync="expanded"
              @item-expanded="expandRow"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item, index}">
                <tr :class="(!item.active)?'red lighten-5':''">
                  <td width="3%">
                    <v-icon
                      @click="editRecord(item.job_id,false)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td width="3%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                      @input="selectRecord(item.job_id)"
                    ></v-simple-checkbox>
                  </td>
                  <td width="19%">{{item.job_name}}</td>
                  <td width="6%">{{(item.uom)?item.uom.ioum_title:''}}</td>
                  <td width="7%">
                    <v-tooltip v-if="item.vendor" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{item.vendor.v_code}}</span>
                      </template>
                      <span>{{item.vendor.v_name}}</span>
                    </v-tooltip>
                  </td>

                  <td width="9%" class="text-right">{{(item.labor_cost)?'$'+item.labor_cost:''}}</td>
                  <td
                    width="10%"
                    class="text-right"
                  >{{(item.material_cost)?'$'+item.material_cost:''}}</td>
                  <td width="9%" class="text-right">{{(item.sales_price)?'$'+item.sales_price:''}}</td>
                  <td
                    width="9%"
                    class="text-right"
                  >{{totalCostCalculate(item.material_cost,item.labor_cost)}}</td>

                  <td width="9%" class="text-center">
                    <v-switch
                      class="pt-0 ma-0 ml-11"
                      v-model="item.px_override"
                      color="success"
                      dense
                      @change="updateJob(index)"
                      hide-details
                    ></v-switch>
                  </td>
                  <td width="7%">
                    <v-text-field
                      style="margin-top: -2px;"
                      v-if="item.px_override"
                      v-model="item.override_price"
                      v-on:keyup="updateJob(index)"
                      type="number"
                      dense
                      hide-details
                    ></v-text-field>
                  </td>
                  <td width="6%">
                    <v-switch
                      class="pt-0 ma-0 ml-3"
                      v-model="item.active"
                      color="success"
                      @change="updateJob(index)"
                      dense
                      hide-details
                    ></v-switch>
                  </td>
                  <td width="3%">
                    <v-icon
                      @click="editRecord(item.job_id,true)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-eye-outline</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected jobs?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteJobs()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Add />
    <Edit />
    <DocList />
    <LogList />
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import Add from "./Add";
import Edit from "./Edit";
import { parseParams } from "../../plugins/helper";
import DocList from "../document/List";
import LogList from "../log/List";
import { mapMutations, mapState } from "vuex";
export default {
  name: "JobList",
  data() {
    return {
      form_data: [],
      open_doc_model_falg: false,
      open_log_model_falg: false,
      setting_data: {},
      showMenu: false,
      setting_menu: false,
      search: "",
      items: {
        data: []
      },
      loading: false,
      delete_dialog: false,
      filter_menu: false,
      status: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["job_name"],
        page: 1,
        filters: {
          active: "1",
          alphabet: ""
        }
      },
      alphabets: [],
      expanded: [],
      search_menu: false
    };
  },
  components: {
    Add,
    Edit,
    LogList,
    DocList
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("job", ["add_job_modal", "edit_job_modal"]),
    ...mapState("document", ["doc_list_modal", "refresh_doc_list"]),
    ...mapState("log", ["log_list_modal", "refresh_log_list"]),
    headers() {
      return [
        { value: "", text: "", sortable: false, width: "3%" },
        { value: "checkbox", text: "#", sortable: false, width: "3%" },
        { value: "job_name", text: "Job Name", sortable: true, width: "19%" },
        { value: "", text: "UOM", width: "6%", sortable: false },
        { value: "", text: "Vendor", sortable: false, width: "7%" },
        {
          value: "",
          text: "Labor Cost",
          sortable: false,
          width: "9%",
          align: "right"
        },
        {
          value: "",
          text: "Material Cost",
          sortable: false,
          width: "10%",
          align: "right"
        },
        {
          value: "",
          text: "Sales Price",
          sortable: false,
          width: "9%",
          align: "right"
        },
        {
          value: "",
          text: "Total Cost",
          sortable: false,
          width: "9%",
          align: "right"
        },
        {
          value: "",
          text: "Px. Override",
          sortable: false,
          width: "9%",
          align: "center"
        },
        { value: "", text: "Price", sortable: false, width: "7%" },
        { value: "", text: "Status", sortable: false, width: "6%" },
        { value: "", text: "", sortable: false, width: "3%" }
      ];
    },
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      return paginationData;
    }
  },
  watch: {
    doc_list_modal: function(value) {
      if (!value) {
        this.open_doc_model_falg = false;
      } else {
        this.open_doc_model_falg = true;
      }
    },
    log_list_modal: function(value) {
      if (!value) {
        this.open_log_model_falg = false;
      } else {
        this.open_log_model_falg = true;
      }
    },
    search() {
      this.getJobs();
    },
    pagination: {
      handler: function() {
        this.getJobs();
      },
      deep: true
    },
    add_job_modal: function(value) {
      if (!value) {
        this.pagination.filters.alphabet = "";
        this.resetFilter();
      }
    },
    edit_job_modal: function(value) {
      if (!value) {
        this.getJobs();
      }
    }
  },
  methods: {
    ...mapMutations("job", ["setJobData"]),
    ...mapMutations("utils", ["setAlert"]),
    ...mapMutations("document", ["setModal", "setDocumentData"]),
    ...mapMutations("log", ["setLogData"]),
    updateJob(index) {
      axios
        .post("inline_edit_job", this.items.data[index])
        .then(function() {})
        .catch(function(error) {
          console.log("FAILURE!!", error);
        });
    },
    resetFilter() {
      this.search = "";
      this.pagination.filters.active = "1";
      this.getJobs();
    },
    selectRecord(val) {
      if (this.open_doc_model_falg || this.open_log_model_falg) {
        this.items.data.filter(item => {
          if (val == item.job_id) {
            if (this.open_doc_model_falg && this.open_log_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openDocList(item);
              this.openLogList(item);
              setTimeout(() => {
                this.openDocList(item);
                this.openLogList(item);
              }, 500);
            } else if (this.open_doc_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.openDocList(item);
            } else if (this.open_log_model_falg) {
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openLogList(item);
            }
          } else {
            item.selected = false;
          }
        });
      }
    },
    openDocList(item) {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 9 });
      this.setDocumentData({ key: "o_id", value: item.job_id });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "form_name", value: "Job" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: item.job_name });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: "" });

      this.setDocumentData({ key: "bank_name", value: "" });

      this.setDocumentData({ key: "project_name", value: "" });

      this.setDocumentData({ key: "vendor_name", value: "" });
    },
    openLogList(item) {
      this.setLogData({ key: "log_list_modal", value: true });
      this.setLogData({ key: "type", value: 9 });
      this.setLogData({ key: "o_id", value: item.job_id });
      this.setLogData({ key: "item", value: item });

      this.setLogData({ key: "form_name", value: "Job" });
      this.setLogData({ key: "item_name", value: "" });
      this.setLogData({ key: "job_name", value: item.job_name });
      this.setLogData({ key: "user_name", value: "" });
      this.setLogData({ key: "customer_name", value: "" });

      this.setLogData({ key: "bank_name", value: "" });

      this.setLogData({ key: "project_name", value: "" });

      this.setLogData({ key: "vendor_name", value: "" });
    },
    updateSetting(is_all_update) {
      this.setting_data.is_all_update = is_all_update;
      let _self = this;
      this.loading = true;
      axios
        .post("update_job_setting", this.setting_data)
        .then(function(response) {
          if (response.data.status) {
            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            _self.loading = false;
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
          _self.loading = false;
        });
    },
    totalCostCalculate(material_cost, labor_cost) {
      let total_cost = material_cost;
      if (labor_cost > 0) {
        total_cost = parseFloat(total_cost) + parseFloat(labor_cost);
      }
      return total_cost > 0 ? "$" + total_cost.toFixed(2) : " ";
    },
    addRecord() {
      this.setJobData({ key: "add_job_modal", value: true });
    },
    editRecord(job_id, is_view_mode) {
      this.setJobData({ key: "edit_job_modal", value: true });
      this.setJobData({ key: "id", value: job_id });
      this.setJobData({ key: "is_view_mode", value: is_view_mode });
    },
    getAlphabets() {
      this.loading = true;
      axios.get("get_alphabets?flag=job").then(response => {
        if (response.data.status) {
          this.alphabets = response.data.data;
        }
        this.loading = false;
      });
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.job_id == itemData.item.job_id) {
            item.expande_icon = "mdi-chevron-up";
            item.selected = true;
          } else {
            item.expande_icon = "mdi-chevron-down";
          }
          return item;
        });
      } else {
        this.items.data = this.items.data.map(function(item) {
          item.expande_icon = "mdi-chevron-down";
          return item;
        });
      }
    },
    deleteJobs() {
      let _self = this;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.job_id);
      });
      axios
        .post("delete_jobs", {
          ids: ids
        })
        .then(function() {
          _self.getJobs();
        })
        .catch(function() {
          console.log("FAILURE!!");
          _self.$Progress.fail();
        });
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getJobs() {
      let _self = this;
      this.loading = true;
      let url = parseParams(this.pageData);
      axios
        .get("job_list?" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.alphabets = response.data.alphabets;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getJobSettings() {
      //let _self = this
      //this.loading = "accent";
      axios
        .get("get_job_setting")
        .then(response => {
          let data = response.data.data;
          for (let key in data) {
            this.setting_data[key] = data[key] == null ? "" : data[key];
          }
          //_self.loading = false;
        })
        .catch(function() {
          //this.loading = false;
        });
    }
  },
  mounted: function() {
    //this.getAlphabets();
    this.getJobSettings();
  }
};
</script>